<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='code_sn' :columns='columns' :data-source='data'>
    <template v-slot:gift_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
        </template>
      </a-card-meta>
    </template>
    <template v-slot:gift="{ record }">
      <a-checkbox v-model:checked="record.is_gift" @change='(e)=>setGift(e,record)'>设为赠品</a-checkbox>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="link" @click='del(record)'>删除</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getOutWarehousingCode } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  let defSearch = {
    page: 1,
    limit: 5,
    product_id:'',
    product_sku_sn:''
  };
  export default {
    components: {},
    name: "warehouseOutCode",
    props: {
      id: {
        type: Number
      },
      showAction: {
        type: Boolean
      },
      productId:{
        type:Number
      },
      productSkuSn:{
        type:String
      }
    },
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        loading:false,
        total: 0,
        giftList:[],
        columns: [
          {
            title: "二维码号",
            dataIndex: "code_sn",
            key: "code_sn"
          },
          {
            title: "二维码类型",
            dataIndex: "code_type_text",
            key: "code_type_text",
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "商品数量",
            dataIndex: "code_num",
            key: "code_num",
          },
          {
            title: "赠品",
            dataIndex: "gift",
            key: "gift",
            slots: { customRender: "gift" },
          }
        ]
      });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //勾选
      const setGift = (e,item) =>{
        if(e.target.checked){
          item.is_gift = 1
        }else{
          item.is_gift = 0
        }
        emit("select", item);
      }
      const initData = async () => {
        state.listLoading = true;
        let res = await getOutWarehousingCode({ ...search.value, sn: props.id,product_id:props.productId,product_sku_sn:props.productSkuSn || 0 }).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData();
        if(props.showAction){
          state.columns.push({
            title: "操作",
            key: "action",
            width:120,
            slots: { customRender: "action" }
          })
        }
      });
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        setGift
      };
    },
  };
</script>